export const lightFromCorner = (side = 'left', delay = 0.2) => {
    const translate = side === 'left'
        ? { x: -100, y: -100 }
        : { x: 100, y: -100 }

    return {
        initial: { ...translate, opacity: 0 },
        animate: { x: 0, y: 0, opacity: 1 },
        transition: { duration: 0.3, delay, ease: 'easeOut' }
    }
}
